var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290,
    height: 1024,
    viewBox: "0 0 290 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "right-a",
    width: 290,
    height: 1024,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right-b",
    x1: "3.248%",
    x2: "89.924%",
    y1: "85.079%",
    y2: "79.268%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.349%",
    stopColor: "#CD0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2648B2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "right-c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#right-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#right-b)",
    mask: "url(#right-c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1111.31514,2511.31605 C738.771317,2514.70033 367.514459,2343.22218 150.62091,1988.14371 C-65.7570599,1633.90931 -35.0812653,1215.55196 154.037251,885.51036 C343.537066,554.803329 692.119149,0 1110.63541,0 C1526.06392,0 1877.32367,556.972678 2071.0537,886.851337 C2267.27089,1220.96505 2573.88989,1778.54047 2349.90302,2123.71698 C2127.64138,2466.23481 1482.83715,2507.94106 1111.31514,2511.31605 L1111.31514,2511.31605 Z M1115.89059,2342.58496 C1432.1594,2339.69992 1749.51778,2189.0121 1938.7244,1897.87147 C2129.39967,1604.47097 2099.9312,1245.76856 1932.89568,961.771446 C1767.97741,681.374136 1468.95743,473.800271 1115.31194,473.800271 C759.037931,473.800271 462.297396,679.530186 300.980222,960.631613 C139.987639,1241.16743 514.960171,1363.8814 699.158149,1664.98112 C883.795027,1966.7983 798.751932,2345.44531 1115.89059,2342.58496 L1115.89059,2342.58496 Z",
    transform: "translate(-1829 -978)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRight);
export default __webpack_public_path__ + "static/media/login-right.dd054a8c7a0d92ccd0c75323319e217f.svg";
export { ForwardRef as ReactComponent };